/* istanbul ignore file */

import React from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import type { CSSProp } from 'styled-components';

import { IconHeartOutlined } from '../../foundations/Iconography/IconHeartOutlined';
import { IconHeartSolid } from '../../foundations/Iconography/IconHeartSolid';
import { OutlineButton } from '../Button/OutlineButton/OutlineButton';
import type { OutlineButtonProps } from '../Button/OutlineButton/types';
import {
  FAVOURITE_BUTTON_CLASSNAME,
  FAVOURITE_ICON_TRANISITION_DURATION_IN_MS,
  FAVOURITE_TRANSITION_CLASSNAME,
} from './constants/favouriteButton';
import * as styles from './FavouriteButton.styles';
import type { ActionButtonSize } from 'client-ribbons-design-system/types/actionButtons';
import type { IconSize } from 'client-ribbons-design-system/types/icons';

export interface FavouriteButtonProps extends OutlineButtonProps {
  active?: boolean;
  className?: string;
  iconStyles?: CSSProp;
  onClick: VoidFunction;
  size: ActionButtonSize;
}

export const FavouriteButton = ({
  active,
  className,
  iconStyles,
  onClick,
  size,
}: FavouriteButtonProps) => {
  const iconSize: IconSize = size === 'small' ? 16 : 24;

  return (
    <div css={styles.favouriteIconTransition}>
      <SwitchTransition mode="in-out">
        <CSSTransition
          classNames={FAVOURITE_TRANSITION_CLASSNAME}
          in={active}
          key={`${FAVOURITE_TRANSITION_CLASSNAME}-${active}`}
          timeout={FAVOURITE_ICON_TRANISITION_DURATION_IN_MS}
        >
          <OutlineButton
            aria-label="Favourite"
            aria-pressed={active}
            className={
              className ? `${FAVOURITE_BUTTON_CLASSNAME} ${className}` : FAVOURITE_BUTTON_CLASSNAME
            }
            css={[styles[size], styles.favouriteButton]}
            onClick={onClick}
            type="button"
          >
            {active ? (
              <IconHeartSolid
                color={`var(--brand-purple-base)`}
                css={iconStyles}
                height={iconSize}
                width={iconSize}
              />
            ) : (
              <IconHeartOutlined
                color={`var(--brand-purple-base)`}
                css={iconStyles}
                height={iconSize}
                width={iconSize}
              />
            )}
          </OutlineButton>
        </CSSTransition>
      </SwitchTransition>
    </div>
  );
};
